import { getChainConfigEntry } from '@/config/chain'
import { TokenDefinition } from '@/domain/types/TokenDefinition'
import { SavingsAccount } from '@/features/savings/logic/savings-converters/types'

export interface GetAccountDisplayedUnderlyingTokenParams {
  account: SavingsAccount
  chainId: number
}

export function getAccountDisplayedUnderlyingToken({
  account,
  chainId,
}: GetAccountDisplayedUnderlyingTokenParams): TokenDefinition {
  const { nativeAssetInfo, tokenDefinitionRepository } = getChainConfigEntry(chainId)

  return account.underlyingToken.address === nativeAssetInfo.wrappedNativeAssetAddress
    ? tokenDefinitionRepository.findOneBySymbol(nativeAssetInfo.nativeAssetSymbol)
    : account.underlyingToken
}
